import { Capacitor } from '@capacitor/core'
import { reactive } from 'vue'
import { toastController, alertController } from '@ionic/vue'
import { informationCircleOutline, closeCircleOutline } from 'ionicons/icons'

let cartCounterRaw = localStorage.getItem('chm_cart') !== null ? JSON.parse(localStorage.getItem('chm_cart')).reduce((t, a) => t + parseInt(a.jlh), 0) : 0

const state = reactive({
  version: '3.1',
  notifCounter: 0,
  cartCounter: cartCounterRaw,
  voucher_disabled: 0, //0: enabled, 1: disabled_room 2: disabled_resto 3: disabled_all
  api_url: Capacitor.isNativePlatform()
    ? 'https://membership.cambridgehotelmedan.co.id/api/'
    : window.location.protocol === 'http:'
    ? 'http://' + window.location.hostname + ':80/chm-membership/api/'
    : './api/',
  key: localStorage.getItem('chm_session') || '',
  lvl: localStorage.getItem('chm_session') ? parseInt(localStorage.getItem('chm_session').slice(-2)) : 0,
  method: { method: 'post', body: JSON.stringify({ key: localStorage.getItem('chm_session') }) },
  loading: false,
  generalKey: 0,
})

const methods = {
  async alertShow(message, tipe) {
    const toast = await toastController.create({
      message: message,
      duration: 2500,
      icon: tipe === 'success' ? informationCircleOutline : closeCircleOutline,
      color: tipe,
      position: 'top',
      cssClass: 'custom-toast',
    })
    return toast.present()
  },
  async modalBox(message, title = '') {
    const mBox = await alertController.create({
      header: title,
      message: message,
      buttons: ['OK'],
      cssClass: 'selectText',
    })
    return mBox.present()
  },
  rupiah: t => new Intl.NumberFormat('id-ID').format(t),
}

export default {
  state,
  methods,
}
